import script from "./ToolbarBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarBottom.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarBottom.vue?vue&type=style&index=0&id=5dccfe48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dccfe48"]])

export default __exports__